import { DanoneMslProduct } from '../entities/danone-msl_product';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class DanoneMslProductRequest extends BaseRequest {
  
  danoneMslProducts : DanoneMslProduct[] = [];

  constructor(userInfo : UserInfo){    
    super(userInfo);
  }

}